module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-Bold.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-Bold.woff
 ** module id = 1103
 ** module chunks = 0
 **/